module.exports = __webpack_public_path__ + "img/delivery_grab.f3618885.png";